import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-94056470")

_pushScopeId("data-v-94056470")
const _hoisted_1 = { class: "company-skill-entry" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex--width flex--halign-sb"
}
const _hoisted_3 = { class: "flex flex--valign-c flex--gap-15" }
const _hoisted_4 = {
  class: "form-check-label",
  for: "checkboxImportant"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HelpButton = _resolveComponent("HelpButton")
  const _component_Icon = _resolveComponent("Icon")
  const _component_GenericSlider = _resolveComponent("GenericSlider")
  const _component_Plane = _resolveComponent("Plane")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Plane, { class: "company-skill-entry-plane flex--width" }, {
      default: _withId(() => [
        _createVNode("div", {
          class: ["company-skill-entry-plane-content flex flex--h flex--width flex--height flex--halign-sb flex--valign-c flex--gap-30", { 'company-skill-entry-plane-content--create': _ctx.create }]
        }, [
          (_ctx.create)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_Transition, {
                  name: "generic-fade",
                  mode: "out-in"
                }, {
                  default: _withId(() => [
                    (_openBlock(), _createBlock("div", {
                      key: `${_ctx.qualification.id}-${_ctx.qualificationNameKey}`,
                      class: "company-skill-entry-text text text--primary-b text--size-20 text--left text--balance text--semi-bold flex flex--valign-c flex--gap-10"
                    }, [
                      _createVNode(_component_HelpButton, {
                        title: _ctx.qualificationNameKey,
                        extra: '_description'
                      }, null, 8, ["title"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.qualificationName) + " ", 1),
                      (_ctx.company && _ctx.companyRequirement?.important)
                        ? (_openBlock(), _createBlock(_component_Icon, {
                            key: 0,
                            class: "company-skill-entry-icon",
                            identifier: 'djf_update_star'
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_3, [
                  _createVNode("input", {
                    id: "checkboxImportant",
                    checked: _ctx.companyRequirement?.important === 1,
                    class: "form-check-input",
                    name: "important",
                    type: "checkbox",
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('createValueChanged', _ctx.realCompanyRequirementValue, _ctx.companyRequirement?.important === 1 ? 0 : 1)))
                  }, null, 40, ["checked"]),
                  _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$trans("qualifications.important")), 1),
                  _createVNode(_component_Icon, {
                    class: "company-skill-entry-icon",
                    identifier: 'djf_update_star'
                  })
                ])
              ]))
            : (_openBlock(), _createBlock(_Transition, {
                key: 1,
                name: "generic-fade",
                mode: "out-in"
              }, {
                default: _withId(() => [
                  (_openBlock(), _createBlock("div", {
                    key: `${_ctx.qualification.id}-${_ctx.qualificationNameKey}`,
                    class: "company-skill-entry-text text text--primary-b text--size-20 text--left text--balance text--semi-bold flex flex--valign-c flex--gap-10"
                  }, [
                    _createVNode(_component_HelpButton, {
                      title: _ctx.qualificationNameKey,
                      extra: '_description'
                    }, null, 8, ["title"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.qualificationName) + " ", 1),
                    (_ctx.company && _ctx.companyRequirement?.important)
                      ? (_openBlock(), _createBlock(_component_Icon, {
                          key: 0,
                          class: "company-skill-entry-icon",
                          identifier: 'djf_update_star'
                        }))
                      : _createCommentVNode("", true)
                  ]))
                ]),
                _: 1
              })),
          _createVNode(_Transition, {
            name: "generic-fade",
            mode: "out-in"
          }, {
            default: _withId(() => [
              (_openBlock(), _createBlock("div", {
                key: _ctx.qualification.id,
                class: "qualification-slider flex--extend flex flex--v flex--valign-c"
              }, [
                (!_ctx.create)
                  ? (_openBlock(), _createBlock(_component_GenericSlider, {
                      key: 0,
                      value: _ctx.realQualificationValue,
                      min: _ctx.sliderMin,
                      max: _ctx.sliderMax,
                      disabled: _ctx.company,
                      onChange: _cache[2] || (_cache[2] = (val) => _ctx.$emit('qualificationValueChanged', val))
                    }, null, 8, ["value", "min", "max", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.company || _ctx.create)
                  ? (_openBlock(), _createBlock(_component_GenericSlider, {
                      key: 1,
                      class: { 'alternate-slider': _ctx.company },
                      value: _ctx.realCompanyRequirementValue,
                      min: _ctx.sliderMin,
                      max: _ctx.sliderMax,
                      disabled: _ctx.company,
                      alternate: _ctx.company,
                      onChange: _cache[3] || (_cache[3] = (val) => _ctx.$emit('createValueChanged', val, _ctx.companyRequirement?.important ?? 0))
                    }, null, 8, ["class", "value", "min", "max", "disabled", "alternate"]))
                  : _createCommentVNode("", true)
              ]))
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            name: "generic-fade",
            mode: "out-in"
          }, {
            default: _withId(() => [
              (_openBlock(), _createBlock("div", {
                key: `${_ctx.qualification.id}-${_ctx.qualificationValueText}`,
                class: "company-skill-entry-text company-skill-entry-text--desc text text--primary-b text--size-18 text--height-22 text--right text--balance text--semi-bold"
              }, _toDisplayString(_ctx.qualificationValueText), 1))
            ]),
            _: 1
          })
        ], 2)
      ]),
      _: 1
    })
  ]))
})